module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom9.cfc9c536.jpg";